import { render, staticRenderFns } from "./CollapseItem.vue?vue&type=template&id=b236aae8&"
import script from "./CollapseItem.vue?vue&type=script&lang=js&"
export * from "./CollapseItem.vue?vue&type=script&lang=js&"
import style0 from "./CollapseItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CollapseItem.vue"
export default component.exports